module.exports = __webpack_public_path__ + "img/card-gold.f8e5e806.svg";